export default __webpack_public_path__ + "static/media/AdamRzymski-TM129_21B_Networ-certificate.702bc02d.pdf";